import classNames from 'classnames'
import {
    FiArrowDownRight,
    FiArrowUpLeft,
    FiCheck,
    FiClock,
    FiEdit3,
} from 'react-icons/fi'
import {
    DepositedTransactionStatusText,
    InProgressTransactionStatusText,
    TransactionStatusText,
    TransactionStatusTextDesign,
} from 'utilities/helper/Funds'

// The pieces a ledger row and the details sheet both draw, kept in one place so
// a transaction looks like the same thing on the list and after it is tapped.

/**
 * Which way the money went. Carried by shape as well as colour: red and green
 * alone are the pair colour-blind readers lose.
 */
export function DirectionTile({
    cashin,
    large = false,
}: {
    cashin: boolean
    large?: boolean
}) {
    const Icon = cashin ? FiArrowDownRight : FiArrowUpLeft
    return (
        <span
            aria-hidden
            className={classNames(
                'flex shrink-0 items-center justify-center',
                large ? 'h-12 w-12 rounded-[14px]' : 'h-9 w-9 rounded-[10px]',
                cashin
                    ? 'bg-success-2 text-success-on'
                    : 'bg-danger-soft text-danger-on'
            )}
        >
            <Icon className={large ? 'h-6 w-6' : 'h-[18px] w-[18px]'} />
        </span>
    )
}

/** «در حال واریز» / «واریز شده» / «ثبت‌شده توسط مدیر» — nothing for the rest. */
export function StatusChip({ status }: { status: string }) {
    const text = TransactionStatusText[status]
    if (!text) return null
    const Icon =
        status === InProgressTransactionStatusText
            ? FiClock
            : status === DepositedTransactionStatusText
            ? FiCheck
            : FiEdit3
    return (
        <span
            className={classNames(
                // nowrap: on a narrow phone the chip drops to its own line whole,
                // rather than breaking «ثبت‌شده توسط / مدیر» inside the pill
                'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold leading-4',
                TransactionStatusTextDesign[status]
            )}
        >
            <Icon aria-hidden className="h-3 w-3 shrink-0" />
            {text}
        </span>
    )
}

export function SignedAmount({
    amount,
    cashin,
    large = false,
}: {
    amount: number | null | undefined
    cashin: boolean
    large?: boolean
}) {
    return (
        <span
            className={classNames(
                'whitespace-nowrap font-bold',
                large ? 'text-2xl leading-9' : 'text-[15px] leading-6',
                cashin ? 'text-success-on' : 'text-danger-on'
            )}
        >
            {/* The sign is isolated with the digits: `+` and `−` are
                bidi-neutral, so loose in an RTL run they get painted at the
                far right of «… تومان», away from the number. Same fix as the
                cashbox ledger. */}
            <span dir="ltr" style={{ unicodeBidi: 'isolate' }}>
                {cashin ? '+' : '−'}
                {(amount ?? 0).toLocaleString()}
            </span>{' '}
            <span
                className={classNames(
                    'font-normal',
                    large ? 'text-sm' : 'text-[11px]'
                )}
            >
                تومان
            </span>
        </span>
    )
}
